import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { get } from 'lodash'

import { getCurrentVenueTimezone, getCurrentVenueUuid } from '../../store/Venues/selector'
import { loadSalesEvents, updateFilter } from '../../store/Event/actions'
import { loadSalesEventTypes } from '../../store/EventType/actions'
import { makeGetPreviousSalesEvents, makeGetFutureSalesEvents, getFilters } from '../../store/Event/selector'
import SuitesEvents from '../../components/Event'

import paginationCoordinator from '../../utils/paginationCoordinator'

const mapStateToProps = (state, ownProps) => {
  const navigation = get(ownProps, 'history', {})

  const showPreviousEvents = getFilters(state).showPreviousEvents
  const getPreviousSalesEvents = makeGetPreviousSalesEvents()
  const getFutureSalesEvents = makeGetFutureSalesEvents()
  const events = showPreviousEvents ? getPreviousSalesEvents(state) : getFutureSalesEvents(state)
  const paginator = paginationCoordinator(events, navigation)
  const currentVenueUuid = getCurrentVenueUuid(state)
  const currentVenueTimezone = getCurrentVenueTimezone(state)

  return {
    currentVenueTimezone,
    currentVenueUuid,
    paginator,
    showPreviousEvents,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    loadSalesEvents: (venueUuid) => {
      dispatch(loadSalesEvents(venueUuid))
    },
    loadSalesEventTypes: () => {
      dispatch(loadSalesEventTypes())
    },
    updateShowPreviousEvents: (value) => {
      dispatch(updateFilter('showPreviousEvents', value))
    },
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SuitesEvents))
